import { Box, Stack, useTheme } from '@mui/material';
import { Controller, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ContentSliderProps } from './home-slider';
import { FC } from 'react';
import SliderItemInfo from './slider-item-info';
import { getDirection } from '@/lang/utils';
import { useRouter } from 'next/router';

export const InfosSlider: FC<ContentSliderProps> = ({
  banners,
  swiper,
  handleSwiper,
}) => {
  const theme = useTheme();
  const { locale } = useRouter();

  const dir = getDirection(locale);

  return (
    <Box
      sx={{
        '.swiper': {
          height: {
            mobile: '225px',
            laptop: '0px',
          },
        },
        '.swiper-slide': {
          backgroundColor: theme.palette.layout.backgroundColor,
        },
      }}
    >
      <Swiper
        onSwiper={handleSwiper}
        dir={dir}
        speed={600}
        loop
        loopedSlides={banners.length * 2}
        modules={[Controller, EffectFade]}
        controller={{
          control: swiper,
        }}
        effect='fade'
      >
        {banners.map(banner => (
          <SwiperSlide key={banner.id}>
            <Stack
              sx={{
                display: {
                  laptop: 'none',
                },
                alignItems: 'center',
                marginBottom: '32px',
              }}
            >
              <SliderItemInfo
                banner={banner}
                primaryColor={theme.palette.grey[60]}
                secondaryColor={theme.palette.grey[50]}
              />
            </Stack>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
